import {createStore} from 'vuex'
import {ProductStore} from '@/store/modules/ProductStore'
import {ReceiverStore} from "@/store/modules/ReceiverStore";
import {ChannelStore} from "@/store/modules/ChannelStore";
import {MemberStore} from "@/store/modules/MemberStore";
import {NextViewStore} from "@/store/modules/NextViewStore";
import {AuthServerStore} from "@/store/modules/AuthServerStore";
import {SortOptionStore} from "@/store/modules/SortOptionStore";
import {AppYnStore} from "@/store/modules/AppYnStore";
import createPersistedState from "vuex-persistedstate";
import {MembershipStore} from "@/store/modules/MembershipStore";

export default createStore({
  modules: {
    ChannelStore,
    AppYnStore,

    SortOptionStore,
    ProductStore,
    ReceiverStore,
    MembershipStore,

    MemberStore,
    NextViewStore,
    AuthServerStore,
  },
  plugins: [
      createPersistedState({
          paths: ["ProductStore", "ReceiverStore", "MembershipStore"],
      })
  ],

});